import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { useSiteData } from "@/context/SiteDataContext";
import { waLink } from "@/lib/api";
import { ACTIVITIES } from "@/lib/activities";
import { LogoMark } from "./Logo";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const ActivityCard = ({ a }) => {
  const { settings } = useSiteData();
  return (
    <article className="group rounded-3xl border border-slate-200 bg-white overflow-hidden flex flex-col hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300" data-testid={`activity-${a.id}`}>
      <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
        <img src={a.img} alt={`${a.name} in the Andaman Islands`} loading="lazy" className={`h-full w-full object-cover ${a.pos || ""} group-hover:scale-105 transition-transform duration-700`} data-testid={`activity-${a.id}-img`} />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F]/70 via-transparent to-transparent" />
        <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 rounded-full bg-white/95 pl-1 pr-3 py-1 shadow">
          <LogoMark className="h-6 w-7" /><span className="text-[11px] font-bold text-navy">Ocean Wings Travel</span>
        </span>
        <h3 className="absolute bottom-4 left-5 right-5 font-display text-2xl sm:text-3xl text-white font-semibold" data-testid={`activity-${a.id}-name`}>{a.name}</h3>
      </div>
      <div className="p-5 sm:p-6 flex flex-col flex-1">
        {a.credit && (
          <p className="-mt-2 mb-3 text-[10px] text-slate-400" data-testid={`activity-${a.id}-credit`}>
            Photo at {a.credit.place}: <a href={a.credit.url} target="_blank" rel="noopener noreferrer" className="underline hover:text-ocean">{a.credit.author}</a>, {a.credit.license}, via Wikimedia Commons
          </p>
        )}
        <p className="text-sm text-slate-600 leading-relaxed flex-1">{a.desc}</p>
        {a.location && <p className="mt-4 flex gap-2 text-xs text-slate-500"><MapPin className="h-3.5 w-3.5 text-ocean shrink-0 mt-0.5" /><span><span className="font-semibold text-navy">Popular at:</span> {a.location}</span></p>}
        <a href={waLink(settings.whatsapp, `Hi Ocean Wings Travel, I'd like to book ${a.name} in Andaman. Date: , Persons: `)} target="_blank" rel="noreferrer" data-testid={`activity-${a.id}-whatsapp`}
          className="mt-5 inline-flex items-center justify-center gap-2 h-11 rounded-full bg-emerald-500 text-white text-sm font-semibold hover:bg-emerald-600 transition-colors">
          <WhatsAppIcon className="h-4 w-4" /> Enquire on WhatsApp
        </a>
      </div>
    </article>
  );
};

export const ActivityGrid = ({ items = ACTIVITIES }) => (
  <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-testid="activity-grid">{items.map((a) => <ActivityCard key={a.id} a={a} />)}</div>
);

export const HomeWaterActivities = () => (
  <section className="container-x pt-24" data-testid="home-water-activities">
    <div className="flex flex-col md:flex-row md:items-end justify-between gap-5">
      <div className="max-w-2xl">
        <p className="eyebrow">Water activities</p>
        <h2 className="mt-3 font-display text-4xl sm:text-5xl text-navy font-semibold leading-tight">Dive, snorkel and splash in the Andaman Sea</h2>
        <p className="mt-3 text-slate-600">Add thrilling water activities to any trip. Ocean Wings Travel arranges them with your package, hotel or ferry booking.</p>
      </div>
      <Link to="/water-activities" className="text-sm font-semibold text-ocean hover:text-navy inline-flex items-center gap-1" data-testid="home-water-activities-all">View all water activities <ArrowRight className="h-4 w-4" /></Link>
    </div>
    <div className="mt-10"><ActivityGrid /></div>
  </section>
);
